import { render } from "./DropdownMultiSelect.vue?vue&type=template&id=5a06000a"
import script from "./DropdownMultiSelect.vue?vue&type=script&lang=js"
export * from "./DropdownMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__